.action {
  padding: 0 4px;
}
